
<ng-template #contactB2BModel let-modal>

  <div class="common-header-flex">
    <div>Add Business</div>
    <button>
      <span id="common_modal_close_business_button" (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div style="margin-bottom: 10px;" *ngIf="!ownerId&&!b2bnetworkcarddata?.id"class="text-info"> *Info: Please enter email address (or) gigsumo BID (or) organization name. </div>
    <form [formGroup]="contactFormBusiness">
      <div class="row mb-3">

        <div class="col-md-6">
          <label for="email" class="form-label">Email Address <span style="color: red;">*</span></label>
          <input maxlength="51" type="email" class="form-control" id="email" formControlName="email"
            (input)="emailBusIDSearch()" placeholder="Enter Email Address">
            <div class="text-danger" *ngIf="contactFormBusiness?.get('email')?.errors?.b2berror">
              {{errorMsgTxt}}
            </div>
          <div *ngIf="
                        contactFormBusiness.get('email').invalid &&  (contactFormBusiness.get('email').dirty ||
                        contactFormBusiness.get('email').touched)" class="text-danger">
            <div *ngIf="contactFormBusiness.get('email').errors.required">Email Address is required</div>

            <div *ngIf="contactFormBusiness.get('email').errors?.maxword">
              {{FORMERROR.EMAIL_MAX}}
            </div>
            <div
              *ngIf=" contactFormBusiness.get('email').errors?.pattern && !contactFormBusiness.get('email').errors?.maxword">
              {{FORMERROR.EMAIL_VALID}}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <label for="platformBusinesId" class="form-label">Gigsumo BID <span style="color: red;">*</span></label>
          <input type="text" maxlength="14" class="form-control" id="platformBusinesId"
            formControlName="platformBusinesId" (input)="BusIDSearch()" (keypress)="restrictSpecialChars($event)"
            placeholder="Enter Gigsumo BID">

          <div class="text-danger" *ngIf="contactFormBusiness.get('platformBusinesId').hasError('required') && contactFormBusiness.get('platformBusinesId').touched">
            Business id is required
          </div>

          <div class="text-danger" *ngIf="contactFormBusiness?.get('platformBusinesId')?.errors?.b2berror">
            {{errorMsgTxt}}
          </div>

          <div  class="text-danger"  *ngIf="contactFormBusiness.get('platformBusinesId').errors?.maxword">
            {{ FORMERROR.PLATFORM_BUSINESSID }}
          </div>

          <div class="text-danger"   *ngIf="contactFormBusiness.get('platformBusinesId')?.errors?.pattern && (contactFormBusiness.get('platformBusinesId').touched || contactFormBusiness.get('platformBusinesId').touched)">
            Business id must be alphanumeric (BID0000000000)
          </div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6">
          <label for="organizationName" class="form-label">Organization Name <span style="color: red;">*</span></label>
          <input maxlength="251" type="text" class="form-control" id="organizationName"
            formControlName="organizationName" (input)="OrganizationSearch()"  placeholder="Search Organization Name">
          <div class="suggestions-list list-group position-absolute" *ngIf="APIResponse.length > 0">
            <div class="suggestion-item list-group-item list-group-item-action" *ngFor="let option of APIResponse"
              (click)="onSelect(option)">
              <strong>{{ option?.businessName }}</strong><br>
              <small>{{ option?.companyLocationDetails[0]?.city }}, {{ option.companyLocationDetails[0]?.state }}, {{
                option.companyLocationDetails[0]?.country }}</small>
            </div>
          </div>
          <div class="text-danger" *ngIf="contactFormBusiness?.get('organizationName')?.errors?.b2berror">
            {{errorMsgTxt}}
          </div>
          <div *ngIf="
            contactFormBusiness.get('organizationName').invalid &&  (contactFormBusiness.get('organizationName').dirty ||
            contactFormBusiness.get('organizationName').touched)" class="text-danger">
            <div *ngIf="contactFormBusiness.get('organizationName').errors.required">Organization name is required</div>

            <div *ngIf="contactFormBusiness.get('organizationName').errors.maxword">
              {{FORMERROR.ORG_MAX}}
            </div>

          </div>
        </div>

        <div class="col-md-6 ">
          <label for="b2bNetworks">Network <span style="color: red;">*</span> </label>
          <ng-select class="multiselectlable" [items]="networks" [addTag]="false" [hideSelected]="false" bindLabel="b2bNetworkName"
            bindValue="b2bNetworkId" dropdownPosition="bottom" formControlName="b2bNetworks" [multiple]="true"
            [closeOnSelect]="false" [clearSearchOnAdd]="true"
            [placeholder]="contactFormBusiness.get('contactType')?.value ? 'Select Networks' : 'Select Business Type first'">

            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="ng-select-checkbox-label">
                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                <span class="ng-select-checkbox-text" [attr.title]="item?.b2bNetworkName">{{item?.b2bNetworkName}}</span>
              </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
              <div class="selected-item" [attr.title]="item?.b2bNetworkName">
                <span class="ng-value-clear remove-icon" (click)="clear(item)">
                  ✕
                </span>
                 
                <span class="ng-value-label">{{ item.b2bNetworkName }}</span>
              </div>
            </ng-template>
          </ng-select>
          <div
            *ngIf="contactFormBusiness.get('b2bNetworks').invalid && (contactFormBusiness.get('b2bNetworks').dirty || contactFormBusiness.get('b2bNetworks').touched)"
            class="text-danger">
            <div   *ngIf="contactFormBusiness.get('b2bNetworks').errors?.required">Network is required
            </div>
          </div>
        </div>

      </div>

      <div class="row mb-3">
        <div class="col-md-6  ">
          <label for="contactType">Business Type <span style="color: red;">*</span></label>
          <!-- Accept flow with a mutual Client/Supplier initiator: the value is forced and
               cannot change, so show a read-only field instead of a dropdown. The reactive
               control still holds "Client/Supplier" and is submitted via getRawValue(). -->
          <ng-container *ngIf="businessTypeLocked; else businessTypeSelect">
            <input id="contactType" type="text" class="form-control"
                   [value]="contactFormBusiness.get('contactType')?.value" disabled />
          </ng-container>
          <ng-template #businessTypeSelect>
            <select formControlName="contactType" id="contactType" class="form-control"
                    (change)="onContactTypeChange()">
              <option  value="null" disabled>Select business type</option>
              <option *ngFor="let type of businessTypes" [value]="type">{{ type }}</option>
            </select>
          </ng-template>
          <div *ngIf="contactFormBusiness.get('contactType').invalid &&
                      (contactFormBusiness.get('contactType').dirty || contactFormBusiness.get('contactType').touched)"
               class="text-danger">
            <div class="text-danger" *ngIf="contactFormBusiness.get('contactType').errors?.required">
              Business Type is required
            </div>
          </div>

          <!-- Reciprocal type validation warning -->
          <div class="type-warning text-warning" *ngIf="typeWarningMessage">
            <small><ng-icon name="tablerAlertTriangle"></ng-icon> {{ typeWarningMessage }}</small>
          </div>

          <!-- subContractAllowed checkbox - visible for Supplier or Customer/Supplier type -->
          <label class="inline-checkbox"
               *ngIf="(contactFormBusiness.get('contactType')?.value === 'Supplier' || contactFormBusiness.get('contactType')?.value === 'Customer/Supplier') && !typeWarningMessage">
            <input type="checkbox" formControlName="subContractAllowed">
            <span class="inline-checkmark"></span>
            <div class="inline-checkbox-text">
              <div>Allow Sub-Contracting</div>
              <small class="text-muted">
                Permit this supplier to sub-contract your jobs to their network
              </small>
            </div>
          </label>

          <!-- Read-only sub-contracting indicator (accept flow) -->
          <div class="sub-contract-info"
               *ngIf="(b2bnetworkcarddata?.id || bannerpassingvalues === 'ACCEPT') && peerSubContractAllowed
                      && contactFormBusiness.get('contactType')?.value === 'Client'">
            <ng-icon name="tablerInfoCircle"></ng-icon>
            <span>Sub-contracting has been allowed by this client for your jobs.</span>
          </div>
        </div>

        <div class="col-md-6  ">
          <label for="organizationType">Organization Type </label>
          <input formControlName="organizationType" id="organizationType" placeholder="" type="text"
            class="form-control" />
          <div
            *ngIf="contactFormBusiness.get('organizationType').invalid && contactFormBusiness.get('organizationType').touched"
            class="text-danger">organization Type is required</div>
        </div>
      </div>
      <div class="row mb-3">
        <div class="col-md-6 ">
          <label for="firstName">First Name</label>
          <input formControlName="firstName" id="firstName" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormBusiness.get('firstName').invalid && contactFormBusiness.get('firstName').touched"
            class="text-danger">First Name is required</div>
        </div>
        <div class="col-md-6  ">
          <label for="lastName">Last Name</label>
          <input formControlName="lastName" id="lastName" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormBusiness.get('lastName').invalid && contactFormBusiness.get('lastName').touched"
            class="text-danger">Last Name is required</div>
        </div>
      </div>

      <div class="row mb-3">
        <div class="col-md-6">
          <label for="role">Role</label>
          <input formControlName="role" id="role" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormBusiness.get('role').invalid && contactFormBusiness.get('role').touched"
            class="text-danger">Role is required</div>
        </div>
        <div class="col-md-6">
          <label for="phone">Phone</label>
          <input formControlName="phone" id="phone" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormBusiness.get('phone').invalid && contactFormBusiness.get('phone').touched"
            class="text-danger">Phone is required</div>
        </div>
      </div>

    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-theme-default w70" (click)="closeModal()">Cancel</button>
    <button type="submit" class="btn  btn-primary w70" (click)="onSubmitBusiness()">Add</button>
  </div>
</ng-template>

<ng-template #contactModal let-modal>

  <div class="common-header-flex">
    <div>{{TYPE ==='EDIT' ? 'Edit' : 'Add'}} Member</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <div style="margin-bottom: 10px;" class="text-info" *ngIf="TYPE != 'EDIT'"> *Info: Please enter email address (or)
      gigsumo no.</div>
    <form [formGroup]="contactFormIndividual">

      <div class="row">
        <div class="col-md-6 col-sm-6 form-group">
          <label for="email">Email Address  <span style="color: red;">*</span></label>
          <input maxlength="51" formControlName="email" id="email" type="email" (input)="onEmailChange()"
            placeholder="Enter email address" class="form-control" />
          <div *ngIf="
              contactFormIndividual.get('email').invalid &&  (contactFormIndividual.get('email').dirty ||
              contactFormIndividual.get('email').touched)" class="text-danger">
            <div *ngIf="contactFormIndividual.get('email').errors.required">Email address is required</div>
            <div *ngIf="contactFormIndividual.get('email').errors.emailError">
              {{errorMsgTxt}}
            </div>
            <div *ngIf="contactFormIndividual.get('email').errors.maxword">
              {{FORMERROR.EMAIL_MAX}}
            </div>
            <div
              *ngIf=" contactFormIndividual.get('email').errors.pattern && !contactFormIndividual.get('email').errors.maxword">
              {{FORMERROR.EMAIL_VALID}}
            </div>
          </div>
        </div>
        <div class="col-md-6 col-sm-6 form-group">
          <label for="phone">Gigsumo No <span style="color: red;">*</span></label>
          <input (keypress)="restrictSpecialChars($event)" maxlength="16" formControlName="gigsumoNo" min
            (input)="onGigsumoidChange()" id="gigsumoNo" placeholder="Gigsumo No" type="text" class="form-control" />
          <div *ngIf=" contactFormIndividual.get('gigsumoNo').invalid  && (contactFormIndividual.get('gigsumoNo').dirty
            || contactFormIndividual.get('gigsumoNo').touched) " class="text-danger">

            <div *ngIf="contactFormIndividual.get('gigsumoNo').errors?.required" class="text-danger">
              Gigsumo No is required</div>

            <div *ngIf="contactFormIndividual.get('gigsumoNo').errors.emailError">
              {{errorMsgTxt}}
            </div>

            <div class="text-danger" *ngIf="contactFormIndividual.get('gigsumoNo')?.errors?.maxword">
              {{FORMERROR.GIGSUMONO}}
            </div>

            <div class="text-danger" *ngIf="contactFormIndividual.get('gigsumoNo')?.value &&contactFormIndividual.get('gigsumoNo').errors?.pattern && (contactFormIndividual.get('gigsumoNo').touched||contactFormIndividual.get('gigsumoNo').touched)">
              Gigsumo id must be alphanumeric (GID000000000)
            </div>
          </div>
        </div>
      </div>



      <div class="row">
        <div class="col-md-6 col-sm-6 form-group">
          <label for="contactType">Contact Type <span style="color: red;">*</span></label>
          <select formControlName="contactType" id="contactType" class="form-control">
            <option  value="null" disabled>Select contact type</option>
            <option *ngFor="let type of contactTypes" [value]="type">{{ type }}</option>
          </select>
          <div *ngIf="contactFormIndividual.get('contactType').invalid &&
                      (contactFormIndividual.get('contactType').dirty || contactFormIndividual.get('contactType').touched)"
               class="text-danger">
            <div class="text-danger" *ngIf="contactFormIndividual.get('contactType').errors?.required">
              Contact Type is required
            </div>
          </div>
        </div>


        <div class="col-md-6 col-sm-6 form-group">
          <label for="businessNetworks">Network <span style="color: red;">*</span></label>
          <ng-select class="multiselectlable" [items]="networks" [addTag]="false" [hideSelected]="false" bindLabel="businessNetworkName"
            bindValue="businessNetworkId" dropdownPosition="bottom" formControlName="businessNetworks" [multiple]="true"
            [closeOnSelect]="false" [clearSearchOnAdd]="true" placeholder="Select Networks">

            <ng-template ng-option-tmp let-item="item" let-item$="item$" let-index="index">
              <div class="ng-select-checkbox-label">
                <span class="ng-select-checkmark" [class.checked]="item$.selected"></span>
                <span class="ng-select-checkbox-text" [attr.title]="item?.businessNetworkName">{{item?.businessNetworkName}}</span>
              </div>
            </ng-template>
            <ng-template ng-label-tmp let-item="item" let-index="index" let-clear="clear">
              <div class="selected-item"  [attr.title]="item?.businessNetworkName">
                <span class="ng-value-clear remove-icon" (click)="clear(item)">
                  ✕
                </span>

                <span class="ng-value-label">{{ item.businessNetworkName}}</span>
              </div>
            </ng-template>

          </ng-select>


          <div
            *ngIf="contactFormIndividual.get('businessNetworks').invalid && (contactFormIndividual.get('businessNetworks').dirty || contactFormIndividual.get('businessNetworks').touched)"
            class="text-danger">
            <div *ngIf="contactFormIndividual.get('businessNetworks').errors?.required">Network is required
            </div>
          </div>
        </div>


      </div>


      <div class="row">
        <div class="col-md-6 col-sm-6 form-group">
          <label for="firstName">First Name</label>
          <input formControlName="firstName" id="firstName" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormIndividual.get('firstName').invalid && contactFormIndividual.get('firstName').touched"
            class="text-danger">First Name is required</div>
        </div>
        <div class="col-md-6 col-sm-6 form-group">
          <label for="lastName">Last Name</label>
          <input formControlName="lastName" id="lastName" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormIndividual.get('lastName').invalid && contactFormIndividual.get('lastName').touched"
            class="text-danger">Last Name is required</div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6 col-sm-6 form-group">
          <label for="organizationName">Organization Name</label>
          <input formControlName="organizationName" id="organizationName" placeholder="" type="text"
            class="form-control" />
          <div
            *ngIf="contactFormIndividual.get('organizationName').invalid && contactFormIndividual.get('organizationName').touched"
            class="text-danger">Organization name is required</div>
        </div>

        <div class="col-md-6 col-sm-6 form-group">
          <label for="organizationType">Organization Type</label>
          <input formControlName="organizationType" id="organizationType" placeholder="" type="text"
            class="form-control" />
          <div
            *ngIf="contactFormIndividual.get('organizationType').invalid && contactFormIndividual.get('organizationType').touched"
            class="text-danger">organization Type is required</div>
        </div>
      </div>



      <div class="row">
        <div class="col-md-6 col-sm-6 form-group">
          <label for="phone">Phone</label>
          <input formControlName="phone" id="phone" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormIndividual.get('phone').invalid && contactFormIndividual.get('phone').touched"
            class="text-danger">Phone is required</div>
        </div>

        <div class="col-md-6 col-sm-6 form-group">
          <label for="role">Role</label>
          <input formControlName="role" id="role" placeholder="" type="text" class="form-control" />
          <div *ngIf="contactFormIndividual.get('role').invalid && contactFormIndividual.get('role').touched"
            class="text-danger">Role is required</div>
        </div>
      </div>

    </form>

  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-theme-default w70" (click)="closeModal()">Cancel</button>
    <button type="submit" class="btn  btn-primary w70" (click)="onSubmit()">{{TYPE === 'EDIT' ? 'Update' : 'Add'}}</button>
  </div>
</ng-template>

<ng-template #networkModal>

  <div class="common-header-flex">
    <div>Add Network</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body" [formGroup]="networkDetailForm">
    <div class="row">
      <div class="col-md-12 col-sm-6">
        <label>Network Name <span style="color: red;">*</span></label>
        <input maxlength="31" class="form-control" type="text" formControlName="businessNetworkName"
          placeholder="Enter network name">
        <div
          *ngIf="(networkDetailForm.controls.businessNetworkName.invalid && (networkDetailForm.controls.businessNetworkName.dirty || networkDetailForm.controls.businessNetworkName.touched))"
          class="text-danger">
          <div *ngIf="networkDetailForm.controls.businessNetworkName.errors?.exists">
            {{errorMsgTxt}}
          </div>
          <div *ngIf="networkDetailForm.controls.businessNetworkName.errors?.required">Network name is
            required</div>
          <div *ngIf="networkDetailForm.controls.businessNetworkName.errors?.minLetters">Minimum 5 chars
            required</div>
          <div *ngIf="networkDetailForm.controls.businessNetworkName.errors?.maxLetters">Maximum 30 chars
            allowed</div>
        </div>
      </div>
    </div>
  </div>


  <div class="modal-footer">
    <button type="button" class="btn  btn-primary w70" (click)="saveOrUpdateNetwork()">
      Save
    </button>
  </div>
</ng-template>

<ng-template #B2BnetworkModal>
  <div class="common-header-flex">
    <div>Add Business Network</div>
    <button>
      <span (click)="closeModal()" class="common-close">&times;</span>
    </button>
  </div>

  <div class="modal-body" [formGroup]="B2bnetworkDetailForm">
    <div class="row">
      <div class="col-md-12 col-sm-6">
        <label>Network Name <span style="color: red;">*</span></label>
        <input maxlength="31" class="form-control" type="text" formControlName="b2bNetworkName"
          placeholder="Enter network name">
        <div
          *ngIf="(B2bnetworkDetailForm.controls.b2bNetworkName.invalid && (B2bnetworkDetailForm.controls.b2bNetworkName.dirty || B2bnetworkDetailForm.controls.b2bNetworkName.touched))"
          class="text-danger">
          <div *ngIf="B2bnetworkDetailForm.controls.b2bNetworkName.errors?.exists">
            {{errorMsgTxt}}
          </div>
          <div *ngIf="B2bnetworkDetailForm.controls.b2bNetworkName.errors?.required">Network name is required</div>
          <div *ngIf="B2bnetworkDetailForm.controls.b2bNetworkName.errors?.minLetters">Minimum 5 chars required</div>
          <div *ngIf="B2bnetworkDetailForm.controls.b2bNetworkName.errors?.maxLetters">Maximum 30 chars allowed</div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 col-sm-6">
        <label for="type">Network Type <span style="color: red;">*</span></label>
        <select formControlName="type" id="type" class="form-control">
          <option value="" disabled>Select network type</option>
          <option value="Client">Client</option>
          <option value="Supplier">Supplier</option>
          <option value="Client_Supplier">Client/Supplier</option>
        </select>

        <div *ngIf="B2bnetworkDetailForm.get('type').invalid &&
                    (B2bnetworkDetailForm.get('type').dirty ||
                     B2bnetworkDetailForm.get('type').touched)" class="text-danger">
          <div *ngIf="B2bnetworkDetailForm.get('type').errors?.required">Network type is required</div>
        </div>
      </div>
    </div>
  </div>

  <div class="modal-footer">
    <button type="button" class="btn btn-default btn-theme-default w70" (click)="closeModal()">Cancel</button>
    <button type="submit" class="btn  btn-primary w70" (click)="saveB2bnetwork()">Add</button>
  </div>
</ng-template>
